var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#filter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 17.3333C4 17.8222 4.4 18.2222 4.88889 18.2222H9.33333V16.4444H4.88889C4.4 16.4444 4 16.8444 4 17.3333ZM4 6.66667C4 7.15556 4.4 7.55556 4.88889 7.55556H12.8889V5.77778H4.88889C4.4 5.77778 4 6.17778 4 6.66667ZM12.8889 19.1111V18.2222H19.1111C19.6 18.2222 20 17.8222 20 17.3333C20 16.8444 19.6 16.4444 19.1111 16.4444H12.8889V15.5556C12.8889 15.0667 12.4889 14.6667 12 14.6667C11.5111 14.6667 11.1111 15.0667 11.1111 15.5556V19.1111C11.1111 19.6 11.5111 20 12 20C12.4889 20 12.8889 19.6 12.8889 19.1111ZM7.55556 10.2222V11.1111H4.88889C4.4 11.1111 4 11.5111 4 12C4 12.4889 4.4 12.8889 4.88889 12.8889H7.55556V13.7778C7.55556 14.2667 7.95556 14.6667 8.44444 14.6667C8.93333 14.6667 9.33333 14.2667 9.33333 13.7778V10.2222C9.33333 9.73333 8.93333 9.33333 8.44444 9.33333C7.95556 9.33333 7.55556 9.73333 7.55556 10.2222ZM20 12C20 11.5111 19.6 11.1111 19.1111 11.1111H11.1111V12.8889H19.1111C19.6 12.8889 20 12.4889 20 12ZM15.5556 9.33333C16.0444 9.33333 16.4444 8.93333 16.4444 8.44444V7.55556H19.1111C19.6 7.55556 20 7.15556 20 6.66667C20 6.17778 19.6 5.77778 19.1111 5.77778H16.4444V4.88889C16.4444 4.4 16.0444 4 15.5556 4C15.0667 4 14.6667 4.4 14.6667 4.88889V8.44444C14.6667 8.93333 15.0667 9.33333 15.5556 9.33333Z",
    fill: "#B4B5B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.72fe4a9b83e7074e050f6bb61d6f40ec.svg";
export { ForwardRef as ReactComponent };